import React, { useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHtml5, faCss3Alt, faJs, faReact, faNodeJs,
  faGitAlt, faGithub
} from '@fortawesome/free-brands-svg-icons';
import { faDatabase, faServer, faWind } from '@fortawesome/free-solid-svg-icons';
import '../Skills.css';

const Skills = ({ skillRefs }) => {
  const skillCategories = [
    {
      title: 'Frontend',
      skills: [
        { name: 'HTML5', icon: faHtml5 },
        { name: 'CSS3', icon: faCss3Alt },
        { name: 'JavaScript', icon: faJs },
        { name: 'React', icon: faReact },
        { name: 'Sass', icon: faCss3Alt }
      ]
    },
    {
      title: 'Backend',
      skills: [
        { name: 'Node.js', icon: faNodeJs },
        { name: 'Express.js', icon: faServer },
        { name: 'SQLite', icon: faDatabase },
        { name: 'MongoDB', icon: faDatabase }
      ]
    },
    {
      title: 'Tools & Others',
      skills: [
        { name: 'Git', icon: faGitAlt },
        { name: 'GitHub', icon: faGithub },
        { name: 'VS Code', icon: faServer },
        { name: 'MS Office', icon: faDatabase },
        { name: 'Google Workspace', icon: faWind }
      ]
    }
  ];

  useEffect(() => {
    // Set refs for skill categories
    skillRefs.current = skillRefs.current.slice(0, skillCategories.length);
  }, [skillRefs, skillCategories.length]);

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2 className="section-title">Technical Skills</h2>
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div 
              key={index} 
              className="skill-category"
              ref={el => skillRefs.current[index] = el}
            >
              <h3>{category.title}</h3>
              <div className="skill-items">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <FontAwesomeIcon icon={skill.icon} />
                    <span>{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
